import ScrollToHelper from '../../00_utilities/helpers/ScrollToHelper';

class ToTop {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.elem.addEventListener('click', () => {
            ScrollToHelper.scrollTo(document.body, 0);
        });
    }
}

export default ToTop;
